<template>
  <div class="chart-2 d-flex align-center justify-center" v-resize="onResize">
    <Loader v-if="loading"></Loader>
    <div v-else id="chart-2"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import API from '@/service'
import Loader from '@/components/UI/Loader'
export default {
  components: {
    Loader
  },
  data: () => ({
    loading: true,
    chart: null,
    option: {
      tooltip: {
        trigger: 'axis'
      },
      xAxis: [
        {
          name: '月份',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: '12'
            }
          }
        }
      ],
      yAxis: [
        {
          name: '活跃供应商数量',
          type: 'value'
        }
      ],
      series: [
        {
          name: '',
          type: 'bar',
          barMinHeight: 0, // 最小柱高
          barWidth: 40, // 柱宽度
          barMaxWidth: 40, // 最大柱宽度
          data: [],
          itemStyle: {
            normal: { // 柱状图颜色
              color: '#3171b7',
              label: {
                show: true, // 显示文本
                position: 'top', // 数据值位置
                textStyle: {
                  color: '#000',
                  fontSize: '14'
                }
              }
            }
          }
        }
      ]
    }
  }),
  async mounted () {
    try {
      const res = await API.getEvalMonthSup()
      // console.log(res)
      this.option.xAxis[0].data = res.data.map(item => item.yearmonth)
      this.option.series[0].data = res.data.map(item => item.livelySupplierNum)
    } catch (error) {
      console.log(error)
    }
    // console.log(this.option)
    this.loading = false
    this.$nextTick(() => {
      this.chart = echarts.init(document.getElementById('chart-2'))
      this.chart.setOption(this.option)
    })
  },
  methods: {
    onResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-2, #chart-2 {
  width: 100%;
  height: 400px;
}
</style>
